<script>
export default {
  props: {
    canSave: {
      type: Boolean,
      default: false,
    },
    isContinue: {
      type: Boolean,
      default: false,
    },
    isAnother: {
      type: Boolean,
      default: false,
    },
    tryingToSave: {
      type: Boolean,
      default: false,
    },
    tryingToDelete: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goBack() {
      this.$emit('go-back')
    },
    tryToSave(action) {
      this.$emit('try-to-save', action)
    },
    tryToDelete() {
      this.$emit('try-to-delete')
    },
  },
}
</script>

<template>
  <v-row class="mt-10" align="center">
    <v-col cols="12" md="6">
      <v-row justify-md="start" justify="center">
        <div
          v-if="!edit && $store.state.calender.addNewRecord === 'false'"
          class="clickable primary--text"
          :class="$style.hrRouterLinkText"
          @click="goBack"
          ><v-icon color="primary">mdi-chevron-left</v-icon> Back</div
        >
      </v-row>
    </v-col>
    <v-col
      v-if="!isContinue && !edit"
      cols="12"
      md="3"
      class="d-flex justify-center"
    >
      <v-btn
        outlined
        rounded
        :loading="tryingToSave"
        :class="$style.hrButtonOutlined"
        class="my-auto primary--text"
        @click="tryToSave('another')"
        >Save & Add Another</v-btn
      >
    </v-col>
    <v-col v-if="edit" cols="12" md="3" class="d-flex justify-end">
      <v-btn
        color="error"
        rounded
        :loading="tryingToDelete"
        :disabled="tryingToDelete"
        :class="$style.hrButtonOutlined"
        class="my-auto"
        @click="tryToDelete"
        >Delete</v-btn
      >
    </v-col>
    <v-col cols="12" md="3" class="d-flex justify-center">
      <v-btn
        v-if="!isAnother"
        rounded
        color="primary"
        :loading="tryingToSave"
        :class="$style.hrButton"
        class="my-auto"
        @click="tryToSave('continue')"
        >Save & Continue</v-btn
      >
    </v-col>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';
.hrButton {
  border-radius: 8px !important;
}
.hrButtonOutlined {
  border-color: $color-theme-light-primary !important;
  border-radius: 8px !important;
}
.hrRouterLinkText {
  font-family: $system-default-font-family;
  font-size: 20px;
}
</style>
